module.exports = __webpack_public_path__ + "img/Icon_Gradient.c324a4be.svg";